import { msalInstance } from '../../App';

export class CustomAzureAlertService {

    async invokeWebAPI(url, httpMethod, msalContext, body = "") {

        // check if msalContext exists
        if (msalContext.accounts.length > 0) {
            const tokenRequest = {
                scopes: [global.ENV_MSAL_LOGIN_REQUEST_SCOPES],
                account: msalContext.accounts[0],
            };

            // acquire Bearer token to include in GET request
            const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
            const token = tokenResponse.accessToken;
            const bearer = `Bearer ${token}`;
            const headers = new Headers();
            headers.append('Accept', '*/*');
            headers.append('Content-Type', 'application/json');
            headers.append('x-northwell-version', '1.0');
            headers.append("Authorization", bearer);
            headers.append('User', msalContext.accounts[0].username)

            var options = {}
            if (body) {
                options = {
                    method: httpMethod,
                    headers: headers,
                    body: body
                };
            } else {
                options = {
                    method: httpMethod,
                    headers: headers
                };
            }

            let response = await fetch(url, options);

            return {
                status: response.status,
                body: await response.json()
            };

        } else {
            console.log('user not logged in')
        }
    }

    //Custom Azure Rule API calls
    async createCustomAzureAlertRule(body, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/azure/create"
        try {
            const response = await this.invokeWebAPI(url, 'POST', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async editCustomAzureAlertRule(id, body, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/azure/" + id
        try {
            const response = await this.invokeWebAPI(url, 'PUT', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async isAlertActionRuleNameExists(Name, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/" + Name + "/exists"
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getCustomAzureAlertRule(msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/azure"
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAzureResourceGroup(msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/azure/resources"
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getCustomAzureAlertRuleById(Id, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/azure/" + Id
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async deleteCustomAzureAlertRule(Id, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/customalert/azure/" + Id
        try {
            const response = await this.invokeWebAPI(url, 'DELETE', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }
}